import s from "./loading.module.css";
import React, { useState, useEffect } from "react";
import SearchBar from "../Home/SearchBar/searchBar";

const Loading = () => {
const [cargando,setCargando] = useState("Cargando")
const [img,setImg] = useState("https://www.superiorlawncareusa.com/wp-content/uploads/2020/05/loading-gif-png-5.gif")

useEffect(() => {
    setTimeout(() => {
        setCargando("Busqueda no encontrada :(");
        setImg("https://i.pinimg.com/originals/fb/ed/b2/fbedb25b550829b8b4c4984b45992b39.gif");
    }, 10500);
  }, []);

  return (
    <div className={s.fondo}>
      <div className={s.box}>
        <div className={s.contCreate}>
           <SearchBar/>
        </div>
        <h1 className={s.activityStuf}>{cargando}</h1>
        <img
          className={s.img}
          src={img}
          alt="loading"
        />
        
      </div>
    </div>
  );
};

export default Loading;
